// extracted by mini-css-extract-plugin
export default {"PoppyTable":"PoppyTable_PoppyTable__6PmXt","header":"PoppyTable_header__5MpLN","body":"PoppyTable_body__pR8C0","row":"PoppyTable_row__GG6Mt"};